export default "__VITE_ASSET__B_WZn8mH__"